/**
 * Mirrors the SmsConsentStatus enum on the server.
 * @readonly
 * @enum {number}
 */
export const SmsConsentStatus = {
    Unknown: 0,
    OptedIn: 1,
    OptedOut: 2,
};

/**
 * Mirrors the SmsConsentSource enum on the server.
 * @readonly
 * @enum {number}
 */
export const SmsConsentSource = {
    Unknown: 0,
    WebForm: 1,
    InboundText: 2,
    Administrator: 3,
};

/**
 * A human-readable label for where a consent decision came from.
 *
 * This is the compliance record: if a tenant ever disputes being texted, this is what says how they
 * agreed, not just that they did.
 * @param source {number}
 * @returns {string}
 */
export function getSmsConsentSourceLabel(source) {
    switch (source) {
    case SmsConsentSource.WebForm:
        return 'Their account page';
    case SmsConsentSource.InboundText:
        return 'Replied by text';
    case SmsConsentSource.Administrator:
        return 'Recorded by staff';
    default:
        return 'No record';
    }
}

/**
 * A human-readable label for a consent value.
 *
 * Unknown reads as "Not asked" rather than "No": the tenant has never been given the choice, which is
 * different from having declined it.
 * @param status {number}
 * @returns {string}
 */
export function getSmsConsentLabel(status) {
    switch (status) {
    case SmsConsentStatus.OptedIn:
        return 'Opted in';
    case SmsConsentStatus.OptedOut:
        return 'Opted out';
    default:
        return 'Not asked';
    }
}
